import React, { useState } from 'react'
import { ButtonImage, ButtonText, ButtonWrapper, Container } from './styles';
import { MenuProps } from './types';


export const Menu: React.FC<MenuProps> = ({
  categories,
  onCategorySelect,
}) => {
  const [selectedButton, setSelectedButton] = useState<number | null>(0);
  const [pressedButton, setPressedButton] = useState<number | null>(null);

  const handleButtonPress = (buttonIndex: number) => {
    setPressedButton(buttonIndex);
  };

  const handleButtonRelease = () => {
    setPressedButton(null);
  };

  const handleButtonClick = (buttonIndex: number, categoryName: string) => {
    setSelectedButton(buttonIndex);
    onCategorySelect(categoryName);
  };

  return (
    <Container length={categories.length}>
      {categories.map((category, index) => (
        <ButtonWrapper
          selected={selectedButton === index}
          pressed={pressedButton === index}
          onMouseDown={() => handleButtonPress(index)}
          onMouseUp={handleButtonRelease}
          onClick={() => handleButtonClick(index, category.name)}
        >
          {
            category.image &&
            <ButtonImage src={category.image} alt={`Category ${category.name}`} />
          }
          <ButtonText>{category.name}</ButtonText>
        </ButtonWrapper>
      ))}
    </Container>
  );
};

export default Menu;